import { BASE_URL } from '../constants';
import { get } from '../requestMethods';
import { NotificationsResponse } from './types';

const URL = `${BASE_URL}/api/notifications`;

export const NOTIFICATIONS_API = {
  getNotifications: () => get<NotificationsResponse>(URL),
};
